$(document).ready(function(){    
    $('#add-item-to-cart').live('click', function(){
      var site_name = $('#site-name').val();
      var facility_code = $('#facility-code').val();
      if(facility_code == null || typeof facility_code === 'undefined' || facility_code == ""){      
        if(site_name == null || typeof site_name === 'undefined' || site_name == "" ){
          alert("Please enter a site name");
          event.preventDefault();   
        }  
      }
    });
});